"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialLayer = void 0;
var GameVars_1 = require("../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var GameConstants_1 = require("../../../GameConstants");
var BoardManager_1 = require("../BoardManager");
var TutorialLayer = /** @class */ (function (_super) {
    __extends(TutorialLayer, _super);
    function TutorialLayer(scene) {
        var _this = _super.call(this, scene) || this;
        TutorialLayer.currentInstance = _this;
        _this.darkBackground = new Phaser.GameObjects.RenderTexture(_this.scene, 0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        _this.add(_this.darkBackground);
        var background = new Phaser.GameObjects.Graphics(_this.scene);
        background.fillStyle(0x321B38);
        background.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        background.alpha = .6;
        _this.darkBackground.draw(background, 0, 0);
        var midContainer = new Phaser.GameObjects.Container(_this.scene);
        midContainer.setPosition(GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2);
        midContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(midContainer);
        _this.textLayout = new Phaser.GameObjects.Image(_this.scene, 0, GameVars_1.GameVars.isDesktop ? -280 : -350, "texture_atlas_1", "shop_cell");
        _this.textLayout.setScale(1.6);
        midContainer.add(_this.textLayout);
        _this.text = new Phaser.GameObjects.Text(_this.scene, 0, GameVars_1.GameVars.isDesktop ? -280 : -350, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["TUTORIAL_1"], { fontFamily: "Baloo", fontSize: "50px", color: "#FFFFFF", align: "center" });
        _this.text.setOrigin(.5);
        _this.text.setStroke("#703E25", 10);
        _this.text.setWordWrapWidth(600);
        midContainer.add(_this.text);
        _this.nextButton = new Utils_1.Button(_this.scene, 0, GameVars_1.GameVars.isDesktop ? 260 : 320, "texture_atlas_1", "btn_ok_off", "btn_ok_on");
        _this.nextButton.onDown(_this.onClickNext, _this);
        midContainer.add(_this.nextButton);
        _this.hand = new Phaser.GameObjects.Image(_this.scene, GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2, "texture_atlas_1", "hand_tutorial_2");
        _this.hand.visible = false;
        _this.hand.setOrigin(0);
        _this.hand.setScale(1, GameVars_1.GameVars.scaleY);
        _this.add(_this.hand);
        _this.tweenHand = _this.scene.tweens.add({
            targets: _this.hand,
            x: _this.hand.x - 20,
            scaleX: .9,
            scaleY: .9 * GameVars_1.GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250,
            repeat: -1,
            yoyo: true
        });
        return _this;
    }
    TutorialLayer.prototype.startTutorialPhase2 = function () {
        this.text.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["TUTORIAL_3"];
        var background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x321B38);
        background.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        background.alpha = 1;
        this.darkBackground.erase(background, 0, 0);
        background.alpha = .6;
        this.darkBackground.draw(background, 0, 0);
        var i = 0;
        var positionAndScale;
        var f;
        if (GameVars_1.GameVars.isDesktop) {
            positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_DESKTOP[i];
            f = .54;
        }
        else {
            if (GameVars_1.GameVars.aspectRatio <= 1.3) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_3[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.45) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_45[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.75) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_75[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 2.05) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_2[i];
            }
            else {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE[i];
            }
            f = .53;
        }
        var x = GameVars_1.GameVars.gameWidth / 2 + 160 * positionAndScale.s;
        var y = GameVars_1.GameVars.gameHeight * f - 125 * GameVars_1.GameVars.scaleY;
        var roundRect = new Phaser.GameObjects.Graphics(this.scene);
        roundRect.fillStyle(0x321B38);
        roundRect.fillRoundedRect(-100, -100, 200, 200, 20);
        roundRect.setScale(positionAndScale.s, positionAndScale.s * GameVars_1.GameVars.scaleY);
        this.darkBackground.erase(roundRect, x, y);
        this.hand.visible = true;
        this.hand.setPosition(GameVars_1.GameVars.gameWidth / 2 + 160 * positionAndScale.s, GameVars_1.GameVars.gameHeight * f - 125 * GameVars_1.GameVars.scaleY);
        this.tweenHand.stop();
        this.tweenHand = this.scene.tweens.add({
            targets: this.hand,
            x: this.hand.x - 20,
            scaleX: .9,
            scaleY: .9 * GameVars_1.GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250,
            repeat: -1,
            yoyo: true
        });
        BoardManager_1.BoardManager.spawnItem(GameVars_1.GameVars.modeGameData.restartCounter + 1, GameVars_1.GameVars.isDesktop ? { c: 4, r: 1 } : { c: 3, r: 2 });
    };
    TutorialLayer.prototype.startTutorialPhase3 = function () {
        this.text.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["TUTORIAL_4"];
        var background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x321B38);
        background.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        background.alpha = 1;
        this.darkBackground.erase(background, 0, 0);
        background.alpha = .6;
        this.darkBackground.draw(background, 0, 0);
        var i = 0;
        var positionAndScale;
        var f;
        if (GameVars_1.GameVars.isDesktop) {
            positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_DESKTOP[i];
            f = .54;
        }
        else {
            if (GameVars_1.GameVars.aspectRatio <= 1.3) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_3[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.45) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_45[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.75) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_75[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 2.05) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_2[i];
            }
            else {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE[i];
            }
            f = .53;
        }
        var x = GameVars_1.GameVars.gameWidth / 2 + 85 * positionAndScale.s;
        var y = GameVars_1.GameVars.gameHeight * f - 125 * GameVars_1.GameVars.scaleY;
        var roundRect = new Phaser.GameObjects.Graphics(this.scene);
        roundRect.fillStyle(0x321B38);
        roundRect.fillRoundedRect(-180, -100, 360, 200, 20);
        roundRect.setScale(positionAndScale.s, positionAndScale.s * GameVars_1.GameVars.scaleY);
        this.darkBackground.erase(roundRect, x, y);
        this.hand.visible = true;
        this.hand.setPosition(GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight * f - 125 * GameVars_1.GameVars.scaleY);
        this.tweenHand.stop();
        this.tweenHand = this.scene.tweens.add({
            targets: this.hand,
            x: GameVars_1.GameVars.gameWidth / 2 + 160 * positionAndScale.s,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 1000,
            repeat: -1,
            yoyo: true
        });
    };
    TutorialLayer.prototype.startTutorialPhase5 = function () {
        this.visible = true;
        this.text.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["TUTORIAL_5"];
        var background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x321B38);
        background.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        background.alpha = 1;
        this.darkBackground.erase(background, 0, 0);
        background.alpha = .6;
        this.darkBackground.draw(background, 0, 0);
        var i = 0;
        var x = GameVars_1.GameVars.gameWidth / 2;
        var y = GameVars_1.GameVars.gameHeight - 90 * GameVars_1.GameVars.scaleY;
        var roundRect = new Phaser.GameObjects.Graphics(this.scene);
        roundRect.fillStyle(0x321B38);
        roundRect.fillRoundedRect(-100, -100, 200, 200, 20);
        roundRect.setScale(1, GameVars_1.GameVars.scaleY);
        this.darkBackground.erase(roundRect, x, y);
        this.hand.visible = true;
        this.hand.setPosition(GameVars_1.GameVars.gameWidth / 2 + 50, GameVars_1.GameVars.gameHeight - 90 * GameVars_1.GameVars.scaleY);
        this.tweenHand.stop();
        this.tweenHand = this.scene.tweens.add({
            targets: this.hand,
            x: this.hand.x - 20,
            scaleX: .9,
            scaleY: .9 * GameVars_1.GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250,
            repeat: -1,
            yoyo: true
        });
    };
    TutorialLayer.prototype.onNext = function () {
        this.nextButton.visible = false;
        this.text.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["TUTORIAL_2"];
        var background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x321B38);
        background.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        background.alpha = 1;
        this.darkBackground.erase(background, 0, 0);
        background.alpha = .6;
        this.darkBackground.draw(background, 0, 0);
        var i = 0;
        var positionAndScale;
        var f;
        if (GameVars_1.GameVars.isDesktop) {
            positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_DESKTOP[i];
            f = .54;
        }
        else {
            if (GameVars_1.GameVars.aspectRatio <= 1.3) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_3[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.45) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_45[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.75) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_75[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 2.05) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_2[i];
            }
            else {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE[i];
            }
            f = .53;
        }
        var x = GameVars_1.GameVars.gameWidth / 2;
        var y = GameVars_1.GameVars.gameHeight * f - 125 * GameVars_1.GameVars.scaleY;
        var roundRect = new Phaser.GameObjects.Graphics(this.scene);
        roundRect.fillStyle(0x321B38);
        roundRect.fillRoundedRect(-100, -100, 200, 200, 20);
        roundRect.setScale(positionAndScale.s, positionAndScale.s * GameVars_1.GameVars.scaleY);
        this.darkBackground.erase(roundRect, x, y);
        this.hand.visible = true;
        this.hand.setPosition(GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight * f - 125 * GameVars_1.GameVars.scaleY);
        this.tweenHand.stop();
        this.tweenHand = this.scene.tweens.add({
            targets: this.hand,
            x: this.hand.x - 20,
            scaleX: .9,
            scaleY: .9 * GameVars_1.GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250,
            repeat: -1,
            yoyo: true
        });
        BoardManager_1.BoardManager.spawnItem(GameVars_1.GameVars.modeGameData.restartCounter + 1, GameVars_1.GameVars.isDesktop ? { c: 3, r: 1 } : { c: 2, r: 2 });
    };
    TutorialLayer.prototype.onClickNext = function () {
        var w = window;
        if (typeof w.gdsdk !== "undefined" && w.gdsdk.showAd !== "undefined") {
            w.gdsdk.showAd();
        }
        else {
            this.onNext();
        }
    };
    return TutorialLayer;
}(Phaser.GameObjects.Container));
exports.TutorialLayer = TutorialLayer;
